import { createElement } from 'react';
import { render } from 'react-dom';
import App from './src/App';
import { store, Template } from './src/store';

/**
 * Public interface
 *
 * This library is meant to be used as a singleton. See index.html for example usage.
 *
 * @type {{addTemplates: (templates: Template[]) => void; hideSettingsPanel: () => void; onSave: (cb: (jsonStr: string) => void) => void; onTestMail: (cb: (to: string, subject: string, body: string) => void) => void; openEditor(elementId: string): void; renderTemplate(): any}}
 */
(window as any).ReactBuilder = {
    addTemplates: (templates: Template[]) => {
        store.templates.push(...(templates || []));
    },
    hideSettingsPanel: () => {
        store.rightPanelComponent = null;
    },
    onSave: (cb: (jsonStr: string) => void) => {
        store.callbacks.saveCb = cb;
    },

    onOrder: (cb: (order_id: number) => Promise<number>) => {
        store.callbacks.fetchOrdercb = cb;
    },

    onShortCode: (cb: (shortcode: string) => Promise<string>) => {
        store.callbacks.doShortCode = cb;
    },

    /*onOrderFetch: (cb: (order_id: number) => Promise<Number>) => {
        store.callbacks.fetchOrderId = cb;
    },*/

    onTestMail: (cb: (to: string, subject: string, body: string) => void) => {
        store.callbacks.testMailCb = cb;
    },
    openEditor(elementId: string) {
        render(<App />, document.getElementById(elementId));
    },
    renderTemplate() {
        return store.renderTemplate();
    },
    fetchOrder: (cb: (order_id: number) => void) => {
        store.callbacks.fetchOrdercb = cb;
    },
    getHistory() {
        return store.getHistory();
    },
    getCurrentTemplate() {
        return store.currentTemplate;
    },
};
